<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <router-link :to="{ path: '/admin/goods/points/list' }">
          <Button icon="ios-arrow-back" size="small" class="mr20">返回</Button>
        </router-link>
        <span
          class="ivu-page-header-title mr20"
          v-text="$route.params.id ? '编辑积分商品' : '添加积分商品'"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="goodsInfo"
            :model='goodsInfo'
            label-position="right"
            :label-width="200"
            :rules="ruleValidate"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">
          <Col span="24">
            <FormItem label="商品名称：" prop="goods_title">
              <Input
                v-model="goodsInfo.goods_title"
                placeholder="请输入商品名称"
                :maxlength="50"
                class="perW50"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="所用积分：" prop="integral">
              <InputNumber
                v-model="goodsInfo.integral"
                placeholder="请输入所用积分"
                :min="0"
                class="perW50"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="商品库存：" prop="stock">
              <InputNumber
                v-model="goodsInfo.stock"
                :min="0"
                placeholder="请输入商品库存"
                class="perW50"
              />
            </FormItem>
          </Col>
      <!--   封面图-->
          <Col span="24">
            <FormItem label="商品封面图 (750*750)">
              <multi_upload ref="uploadThumb"></multi_upload>
            </FormItem>
          </Col>
        <!--  轮播图-->
          <Col span="24">
            <FormItem label="商品轮播图 (750*750)">
              <div style="color: red">(最多5张)</div>
              <multi_upload ref="uploads" :picNum="5"></multi_upload>
            </FormItem>
          </Col>
<!--          其他-->
          <Col span="8">
            <FormItem label="商品状态：">
              <RadioGroup v-model="goodsInfo.status">
                <Radio :label="1" class="radio">上架</Radio>
                <Radio :label="0">下架</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="排序：">
              <InputNumber
                :min="0"
                class="perW80"
                v-model="goodsInfo.sort"
                placeholder="请输入排序"
              />
            </FormItem>
          </Col>
        <!-- 商品详情-->
          <Col span="24">
              <FormItem label="商品详情：" prop="goods_detail">
                <ueditor ref="ueDetail" :content="goodsInfo.goods_detail"></ueditor>
              </FormItem>
          </Col>
        </Row>
        <FormItem>
          <Button
            type="primary"
            class="submission"
            @click="handleSubmit('goodsInfo')"
          >保存</Button>
        </FormItem>

      </Form>
    </card>

  </div>

</template>
<script>
import { addGoods, goodsInfoApi } from '@/api/goods/pointsGoods'
import Setting from '@/setting'
import ueditor from '@/components/ueditorFrom/index'
import multi_upload from '_c/multi_upload/index'
export default {
  name: 'pointsGoodsEdit',
  components: { ueditor, multi_upload },
  data () {
    return {
      editor: null,
      server_url: Setting.serverSrc,
      serverApiPic: Setting.serverApiPic,
      imgUrl: '',
      visible: false,
      goodsInfo: {
        goods_point_id: 0,
        category_id: 0,
        goods_title: '',
        goods_detail: '',
        status: 1,
        sort: 0,
        thumb: '',
        stock: 0,
        is_hot: 0,
        integral: 0,
        sale_price: 0,
        delpics: [], // 服务器待删除的照片
        goods_pics: []
      },
      uploadList: [], // 缩咯图
      ruleValidate: {
        goods_title: [
          { required: true, message: '请输入商品标题', trigger: 'blur' }
        ],
        goods_detail: [
          { required: true, message: '请输入商品详情', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.goodsInfoEdit(this.$route.params.id)
    }
  },
  mounted () {
    this.uploadPics = this.$refs.uploads.fileList
  },
  methods: {
    handleView (url) {
      this.imgUrl = url
      this.visible = true
    },
    handleSubmit (name) {
      if (this.goodsInfo.integral <= 0) {
        this.$Message.error('商品积分有误')
        return
      }
      if (this.goodsInfo.stock <= 0) {
        this.$Message.error('商品库存有误')
        return
      }
      if (this.$refs.uploadThumb.uploadPics.length <= 0) {
        this.$Message.error('封面图必填')
        return
      }
      this.goodsInfo.thumb = this.$refs.uploadThumb.uploadPics[0]['url']
      if (this.$refs.uploads.uploadPics.length <= 0) {
        this.$Message.error('轮播图必填')
        return
      }
      this.$refs.uploads.uploadPics.map((item, index) => {
        this.goodsInfo.goods_pics.push(item.url)
      })
      this.goodsInfo.goods_detail = this.$refs.ueDetail.contents
      this.$refs[name].validate(valid => {
        if (valid) {
          // console.log(this.goodsInfo);return;
          addGoods(this.goodsInfo).then(res => {
            let msg = '添加成功'
            if (this.goodsInfo.goods_point_id > 0) {
              msg = '编辑成功'
            }
            this.$Message.success(msg)
            if (res.code === 200) {
              setTimeout(() => {
                this.$router.push({ path: '/admin/goods/points/list' })
              }, 500)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },
    // 编辑加载数据
    goodsInfoEdit (id) {
      let data = { 'goods_point_id': id }
      goodsInfoApi(data).then(res => {
        // console.log(res)
        this.goodsInfo = res.data
        this.$refs.ueDetail.contents = this.goodsInfo.goods_detail
        this.$refs.uploadThumb.uploadPics.push({ 'url': this.goodsInfo.cover, 'showProgress': false, 'percentage': 100, 'status': 'finished' })//  缩略图
        // 轮播图
        if (this.goodsInfo.goods_pics.length > 0) {
          this.$refs.uploads.uploadPics = []
          this.goodsInfo.goods_pics.map((item) => {
            this.$refs.uploads.uploadPics.push({ 'url': item, 'showProgress': false, 'percentage': 100, 'status': 'finished' })//  轮播图
          })
          this.goodsInfo.goods_pics = []
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    }
  }
}
</script>
